import React, { Fragment } from "react";

import { Box, Divider } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import { times } from "lodash";

const AreaDiscountsSkeleton = () => (
  <Fragment>
    {times(2, idx => (
      <Fragment key={idx}>
        <Divider />
        <Box paddingY={1} paddingX={2}>
          <Skeleton width="320px" height="60px" />
        </Box>
      </Fragment>
    ))}
  </Fragment>
);

export default AreaDiscountsSkeleton;
